// extracted by mini-css-extract-plugin
export default {"root":"yqcG4GXAcoQXVaU4_AkQ","klass":"Gan0ypZueT0B360akaMV","placeHolderShimmer":"I4eSQ1ETyzSnIDgxwmCR"};